import axios from "axios";
import { useContext, useEffect, useState } from "react";
import Marquee from "react-fast-marquee";
import {
  FaFacebookSquare,
  FaInstagramSquare,
  FaLinkedin,
} from "react-icons/fa";
import { FaLocationDot, FaSquarePhone, FaYoutube } from "react-icons/fa6";
import { GrDocumentUser } from "react-icons/gr";
import { HiMail } from "react-icons/hi";
import { MdOutgoingMail, MdPhoneForwarded } from "react-icons/md";
import { RiTwitterXLine } from "react-icons/ri";
import { VscNotebookTemplate } from "react-icons/vsc";
import { Link } from "react-router";
import { AppContext } from "../../AppProvider";
import CBSGCharLoader from "../../Page/CBSGCharLoader";
import Line from "../Line/Line";
const Footer = () => {
  const [data, setdata] = useState("");
  const [error1, setError] = useState(null);
  const { uri, About } = useContext(AppContext);
  const [loading1, setLoading1] = useState(true);
  // console.log(footerInfo);
  // console.log(About);
  useEffect(() => {
    const fetchData = async () => {
      try {
        const response = await axios.get(`${uri}footer/`);
        setdata(response.data[0]);
      } catch (error) {
        if (error.response) {
          setError(`Error: ${error.response.status} - ${error.response.data}`);
        } else if (error.request) {
          setError("Error: No response received from the server");
        } else {
          setError(`Error: ${error.message}`);
        }
      } finally {
        setLoading1(false);
      }
    };
    fetchData();
  }, []);
  // console.log(data);

  if (loading1) {
    return (
      <div className="flex justify-center items-center h-[40rem]">
        <CBSGCharLoader />
      </div>
    );
  }

  return (
    <div className="bg-gradient-to-tr from-base_600 to-indigo-900 text-white">
      <Line />

      <footer className="max-w-7xl mx-auto py-12 px-6">
        {/* Top Section */}
        <div className="grid grid-cols-1 md:grid-cols-3 gap-12">
          {/* Branding */}
          <div className="space-y-4 text-center md:text-left ">
          <div className="">
          <h2 className="text-lg font-semibold border-b border-white pb-1">
          Click to download
            </h2>
          
          <div className="text-base mb-4 py-2 text-center md:text-left flex gap-10">
            <a
              href={About?.company_profile}
              download="CBSG-Profile.pdf"
              className="hover:underline hover:cursor-pointer flex items-center gap-2"
            >
              <GrDocumentUser />
              CBSG Profile
            </a>
            <a
              href={About?.cbsg_brochure}
              download="CBSG-Brochure.pdf"
              className="hover:underline hover:cursor-pointer flex items-center gap-2"
            >
              <VscNotebookTemplate />
              CBSG Brochure
            </a>
          </div>
        </div>
            <Link href="/">
              <img
                src={About?.logo}
                alt="CBSG Logo"
                className="mx-auto md:mx-0 w-36"
              />
            </Link>
            <h1 className="text-xl font-bold">
              Capacity Building Service Group
            </h1>
            <Marquee gradient={false} speed={50}>
              <p className="text-xs">Supporting Greater Performance</p>
            </Marquee>
            <p className="text-xs">
              © {new Date().getFullYear()} - All rights reserved
            </p>
            
          </div>

          {/* Address Info */}
          <div className="space-y-4 text-sm">
            <h2 className="text-lg font-semibold border-b border-white pb-1">
              Our Offices
            </h2>

            <div>
              <div className="font-medium flex items-start gap-2 ">
                <p className="">
                  <FaLocationDot />
                </p>
                <div
                  className="font-normal "
                  dangerouslySetInnerHTML={{ __html: data?.address }}
                />
              </div>
              <div className="font-medium flex items-start gap-2 mb-8">
                <p className="">
                  <FaLocationDot />
                </p>
                <div
                  className="font-normal "
                  dangerouslySetInnerHTML={{ __html: data?.address2 }}
                />
              </div>
              <div className="font-medium flex items-start gap-2 ">
                <p className="">
                  <FaLocationDot />
                </p>
                <div
                  className="font-normal "
                  dangerouslySetInnerHTML={{ __html: data?.address3 }}
                />
              </div>
              <div className="font-medium flex items-start gap-2 mb-2">
                <p className="">
                  <FaLocationDot />
                </p>
                <div
                  className="font-normal "
                  dangerouslySetInnerHTML={{ __html: data?.address4 }}
                />
              </div>
            </div>
          </div>

          {/* Contacts and Socials */}
          <div className="space-y-4 text-sm">
            <h2 className="text-lg font-semibold border-b border-white pb-1">
              Contact
            </h2>
            <p className="flex flex-col gap-2">
              <span className="font-medium flex items-center justify-start gap-2">
                <HiMail /> Email:
              </span>
              <a
                href="mailto:info@cbsg-bd.org"
                className=" flex items-center gap-2"
              >
                <MdOutgoingMail /> {data.email}
              </a>{" "}
              <a
                href="mailto:joyanta@cbsg-bd.org"
                className=" flex items-center gap-2"
              >
                <MdOutgoingMail />
                {data.email2}
              </a>
            </p>
            <p className="flex flex-col gap-2">
              <span className="font-medium flex items-center justify-start gap-2">
                <FaSquarePhone /> Phone:{" "}
              </span>

              <a href={`tel:${data.phone}`} className="flex items-center gap-2">
                <MdPhoneForwarded />
                {data.phone}
              </a>
              <a
                href={`tel:${data.phone2}`}
                className="flex items-center gap-2"
              >
                <MdPhoneForwarded />
                {data.phone2}
              </a>
              <a
                href={`tel:${data.phone3}`}
                className="flex items-center gap-2"
              >
                <MdPhoneForwarded />
                {data.phone3}
              </a>
            </p>
            <p>
            <span className="font-medium flex items-center justify-start gap-2">
                <HiMail /> Canada Email:
              </span> 
              <a
                href="mailto:Joyanta.roy@cbsg-canada.org"
                
              >
                joyanta.roy@cbsg-canada.ca 
              </a>
            </p>
            <div className="flex gap-4 text-2xl pt-2">
              <a href={`${data?.facebook}`} target="_blank">
                <FaFacebookSquare />
              </a>
              <a href={`${data?.twitter}`} target="_blank">
                <RiTwitterXLine />
              </a>
              <a href={`${data?.linkedin}`} target="_blank">
                <FaLinkedin />
              </a>
              <a href={`${data?.instagram}`} target="_blank">
                <FaInstagramSquare />
              </a>
              <a href={`${data?.website}`} target="_blank">
                <FaYoutube />
                
              </a>
            </div>
          </div>
        </div>

        {/* Partner Logos Section */}
        
      </footer>
    </div>
  );
};

export default Footer;
